import { render, staticRenderFns } from "./ProductCatalogEntityProxy.vue?vue&type=template&id=a5281056&"
import script from "./ProductCatalogEntityProxy.vue?vue&type=script&lang=ts&"
export * from "./ProductCatalogEntityProxy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports